// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.7.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.7.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SmsComplianceDialog-module__dialogBox--LxPNE{width:60rem;max-height:calc(100vh - 2rem)}.SmsComplianceDialog-module__dialogBox--LxPNE h3{font-weight:normal;text-transform:uppercase;margin:0 0 10px 0;border-bottom:1px solid var(--xm-main-border-color);padding:10px 0;color:var(--xm-secondary-text-color);text-transform:uppercase}.SmsComplianceDialog-module__content--EnneN{font-size:.75rem;text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialogBox": "SmsComplianceDialog-module__dialogBox--LxPNE",
	"content": "SmsComplianceDialog-module__content--EnneN"
};
export default ___CSS_LOADER_EXPORT___;
